module.exports = __webpack_public_path__ + "assets/51e2f7581b94abab7fdbcdace9988d5a.svg";